import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';

import { BusLocationMap, StopCode } from '../model/realtime.models';

@Injectable()
export class RealtimeActions {
    static SET_LOCATIONS = '[Realtime]: Set locations';
    static CLEAR_EXPIRED_LOCATIONS = '[Realtime]: Clear expired locations';
    static SET_SELECTED_LOCATION = '[Realtime]: Set selected location';
    static SET_SHAPES = '[Realtime]: Set shapes';

    static FETCH_SHAPES = '[Realtime]: Fetch shapes';
    static FETCH_SHAPES_FAILED = '[Realtime]: Fetch shapes failed';

    static SET_REALTIME_SCHEDULE = '[Realtime]: Set realtime schedule table';
    static CLEAR_REALTIME_SCHEDULE = '[Realtime]: Clear realtime schedule table';

    setLocations(payload: BusLocationMap): RidangoReduxAction {
        return {
            type: RealtimeActions.SET_LOCATIONS,
            payload: payload
        };
    }

    setSelectedLocation(payload: any): RidangoReduxAction {
        return {
            type: RealtimeActions.SET_SELECTED_LOCATION,
            payload: payload
        };
    }

    setShapes(payload: any): RidangoReduxAction {
        return {
            type: RealtimeActions.SET_SHAPES,
            payload: payload
        };
    }

    fetchShapes(tripId: number): RidangoReduxAction {
        return {
            type: RealtimeActions.FETCH_SHAPES,
            payload: tripId
        };
    }

    fetchShapesError(error): RidangoReduxAction {
        return {
            type: RealtimeActions.FETCH_SHAPES_FAILED,
            payload: error
        };
    }

    clearExpiredLocations(): RidangoReduxAction {
        return {
            type: RealtimeActions.CLEAR_EXPIRED_LOCATIONS
        };
    }

    setRealtimeSchedule(payload: StopCode): RidangoReduxAction {
        return {
            type: RealtimeActions.SET_REALTIME_SCHEDULE,
            payload: payload
        };
    }

    clearRealtimeSchedule(): RidangoReduxAction {
        return {
            type: RealtimeActions.CLEAR_REALTIME_SCHEDULE
        };
    }
}
